//imports
import {
    DETAILS_LAST_READING_REQUEST,
    DETAILS_LAST_READING_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    result: null,
    loading: false,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DETAILS_LAST_READING_REQUEST:
            return { ...state, loading: true }

        case DETAILS_LAST_READING_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DETAILS_LAST_READING"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};